import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AddAiChatMessageMutationVariables = Types.Exact<{
  message: Types.Scalars['String']['input'];
  userId: Types.Scalars['String']['input'];
  workspaceId: Types.Scalars['Int']['input'];
  aiChatId?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type AddAiChatMessageMutation = { __typename?: 'mutation_root', newWebAiChatMessage?: Array<{ __typename?: 'webAiChatMessageOutput', id: string, message: string, isSystem: boolean, createdAt: string, userId?: string | null, chatId: string, user?: { __typename?: 'users', id: string, firstName: string, lastName: string, profilePhotoLink?: string | null } | null, webAiChat?: { __typename?: 'webAiChats', id: any, aiChatId: string, workspaceId?: number | null, partitionId?: string | null, organizationId?: string | null, createdAt?: any | null } | null } | null> | null };


export const AddAiChatMessageDocument = gql`
    mutation addAiChatMessage($message: String!, $userId: String!, $workspaceId: Int!, $aiChatId: String) {
  newWebAiChatMessage(
    message: $message
    userId: $userId
    workspaceId: $workspaceId
    chatId: $aiChatId
  ) {
    id
    message
    isSystem
    createdAt
    userId
    user {
      id
      firstName
      lastName
      profilePhotoLink
    }
    chatId
    webAiChat {
      id
      aiChatId
      workspaceId
      partitionId
      organizationId
      createdAt
    }
  }
}
    `;
export type AddAiChatMessageMutationFn = Apollo.MutationFunction<AddAiChatMessageMutation, AddAiChatMessageMutationVariables>;

/**
 * __useAddAiChatMessageMutation__
 *
 * To run a mutation, you first call `useAddAiChatMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAiChatMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAiChatMessageMutation, { data, loading, error }] = useAddAiChatMessageMutation({
 *   variables: {
 *      message: // value for 'message'
 *      userId: // value for 'userId'
 *      workspaceId: // value for 'workspaceId'
 *      aiChatId: // value for 'aiChatId'
 *   },
 * });
 */
export function useAddAiChatMessageMutation(baseOptions?: Apollo.MutationHookOptions<AddAiChatMessageMutation, AddAiChatMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddAiChatMessageMutation, AddAiChatMessageMutationVariables>(AddAiChatMessageDocument, options);
      }
export type AddAiChatMessageMutationHookResult = ReturnType<typeof useAddAiChatMessageMutation>;
export type AddAiChatMessageMutationResult = Apollo.MutationResult<AddAiChatMessageMutation>;
export type AddAiChatMessageMutationOptions = Apollo.BaseMutationOptions<AddAiChatMessageMutation, AddAiChatMessageMutationVariables>;